import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../../core'
import * as changeImpact from '../change-impact'

export const RESOURCE = {
  payload: {
    canBeOptional: true,
    context: core.dms.models.Attribute.Id.Context.from({
      context: changeImpact.RESOURCE.payload.dimension.partialId,
      partialId: changeImpact.RESOURCE.payload.partialId,
      type: core.dms.models.Type.Entity,
    }),
    description: 'Subtopic one for this change impact.',
    isOptional: true,
    name: 'Subtopic One',
    partialId: PartialId.Standard.create('subtopic_one'),
    type: core.common.value.types.Intrinsic.Text,
  },
  type: core.quiver.Resource.Type.DmsAttribute,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsAttribute>
